import React from 'react'

const SearchBar = (
    {handleInputChange}
) => {
  return (
    <header className="header">
            <input
            onChange = {(e) => handleInputChange(e.target.value)}
            type="text" className='header__search_bar' placeholder='Search by name, email or role' />
    </header>
  )
}

export default SearchBar